import React from "react";

export const HiringGridHeader = () => {
  return (
    <div className="overflow-x-auto -mx-4 px-4 md:overflow-visible md:px-0 md:mx-0">
      <div className="grid grid-cols-7 gap-4 mb-4 text-sm font-medium text-gray-600 min-w-[800px] md:min-w-0">
        <div>Department</div>
        <div>Start Headcount</div>
        <div>Growth Hires</div>
        <div>End Headcount</div>
        <div>% Attrition</div>
        <div>Backfill Hires</div>
        <div>Total Hires</div>
      </div>
    </div>
  );
};